import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormControl } from "react-bootstrap";

import { setFancyName } from "@parts/person/personAdaptToCompany/actions";

import CRT from "./crt";
import StateRegistry from "./stateRegistry";
import CNAE from "./cnae";
import MunicipalRegistry from "./municipalRegistry";

class PersonAdaptToCompany extends React.Component {
  constructor(props) {
    super(props);
    this._onChange = this._onChange.bind(this);
  }

  _onChange(e) {
    this.props.setFancyName(e.target.value);
  }
  render() {
    const { fancyName, loading } = this.props;
    return (
      <div className="row">
        <div className="col-lg-6 col-sm-12">
          Nome Fantasia
          <FormControl
            placeholder="Insira aqui o Nome Fantasia"
            disabled={loading}
            maxLength={60}
            onChange={this._onChange}
            value={fancyName}
          />
        </div>
        <div className="col-sm-12 col-lg-6">
          <MunicipalRegistry />
        </div>
        <StateRegistry />
        {this.props.crt ? <CRT /> : <div />}
        <div className="row py-1">
          {this.props.cnae ? <CNAE /> : <div />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fancyName: state.fancyName,
  loading: state.loading,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFancyName,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonAdaptToCompany);



// WEBPACK FOOTER //
// ./src/components/parts/person/personAdaptToCompany/index.jsx